import axios from "axios";
import router from "@/router";
import qs from "qs";
import {Message, Loading, MessageBox} from "element-ui";
import {CustomLoading} from "@/utils/loading";
import i18n from "@/config/i18n"

let loading = new CustomLoading(Loading)

//  创建axios实例
const instance = axios.create();


// 响应拦截
instance.interceptors.response.use(
  (resp) => {
    //如果未授权，则跳转至授权页面
    if (resp.data.status === 401) {
      sessionStorage.removeItem("login-user-info");
      router.push("/login");
    }
    return resp;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    // 添加 token
    const areaData = sessionStorage.getItem("areaData");
    config.headers.language = encodeURIComponent(areaData);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 *  封装axios请求
 * @param action 请求地址
 * @param data 请求参数
 * @param config 请求配置
 */
const DEFAULT_CONFIG = {
  showLoading: true, // 是否显示 loading
  isJson: false, // 请求参数是否是 json, 默认 formData
  showErrorTip: true, // 是否显示错误提示
  requestConfig: {}, // 请求配置
}
const request = async (action, data, config) => {
  config = Object.assign({}, DEFAULT_CONFIG, config);
  if (config.showLoading) {
    loading.showLoading();
  }

  return new Promise((resolve, reject) => {
    let params = config.isJson ? data : qs.stringify(data);
    instance.post(action, params, config.requestConfig).then(res => {
      loading.hideLoading();

      if (res.data.status !== 200) {
        reject(res);
        showMessage(res.data.desc, config.showErrorTip);
        return;
      }
      resolve(res.data.data);
    }).catch(err => {
      loading.hideLoading();
      if(err?.response) {
        let {data: res} = err.response;

        if(res?.errors && Array.isArray(res.errors)) {
          res.errors.forEach(item => {
            showMessage(item.defaultMessage, config.showErrorTip);
          })
        } else {
          showMessage(res.desc || res.message, config.showErrorTip);
        }
      }
      reject(err);
    })
  })
}

/**
 *  封装消息提示 请求
 *   @param requestOption 请求参数，跟配置 request 请求一致
 *   @param tipOption 提示参数，跟 element ui 配置一致
 * @type {{title: string, message: string, type: string, confirmButtonText: string, cancelButtonText: string}}
 */
const DEFAULT_TIP_OPTION = {
  title: '提示',
  message: "是否确定删除该记录",
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  type: 'warning'
}
const requestByTip = (action, data, requestConfig, tipOption) => {
  let {
    message,
    title,
    confirmButtonText,
    cancelButtonText,
    type
  } = Object.assign({}, DEFAULT_TIP_OPTION, tipOption);

  return new Promise((resolve, reject) => {
    MessageBox.confirm(i18n.t(message), i18n.t(title), {
      confirmButtonText: i18n.t(confirmButtonText),
      cancelButtonText: i18n.t(cancelButtonText),
      type
    }).then(() => {
      request(action, data, requestConfig)
        .then(res => resolve(res))
        .catch(err => reject(err))
    }).catch(() => {
    })
  })
}


/**
 *  错误提示
 * @param message 提示内容
 * @param isShowTip 是否显示
 * @type {Set<any>}
 */
let messageSet = new Set();
const showMessage = (message, isShowTip) => {
  if (!isShowTip || messageSet.has(message)) return;
  message = message || "请求失败";
  messageSet.add(message);
  Message({
    message,
    type: 'error',
    onClose: () => {
      messageSet.delete(message);
    }
  })
}

export {
  requestByTip,
  request,
}
